import React from "react"
import TecImg from "../../images/tecnologias.png"
import TecImgMobile from "../../images/tecnologias-mobile.png"
import { Link } from "gatsby"

const Tecnology = () => {
  return (
    <section className="bg-primary">
      <div className="container mx-auto py-20 px-6">
        <div className="flex flex-col-reverse md:flex-row items-center">
          <div className="w-full md:w-1/2 md:pr-12">
            <img
              src={TecImgMobile}
              alt="Our technologies"
              className="mx-auto md:hidden"
            />
            <img
              src={TecImg}
              alt="Our technologies"
              className="mx-auto hidden md:block"
            />
          </div>
          <div className="w-full md:w-1/2 text-white font-normal text-center md:text-left pb-8">
            <h3 className="pb-8 text-5xl leading-tight">
              <span className="font-bold block">Our</span> technologies
            </h3>
            <p className="pb-8">
              We work with the latest cutting-edge technologies, providing
              continuous training in new technological and digital trends
            </p>
            <Link
              to="/services/our-technologies/"
              className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white border-white border-solid border-2 hover:bg-secondary hover:text-variant btn"
            >
              Find out by yourself!
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Tecnology
